
import ActionMenu from '@/components/ActionMenus/ActionMenuComponent.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import TextInput from '@/components/Forms/Elements/TextInputComponent.vue';
import IconComponent from '@/components/IconComponent.vue';
import clickOutside from '@/util/directives/clickOutside';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import DateSelector from '@/components/Forms/Elements/DateSelectorComponent.vue';

@Component<DateFilterComponent>({
  components: {
    ActionMenu,
    ButtonComponent,
    DateSelector,
    TextInput,
    IconComponent
  },
  directives: {
    clickOutside
  }
})
export default class DateFilterComponent extends Vue {
  @Prop()
  label!: string;

  @Prop({ default: false })
  showSubMenu!: string;

  selectedDate: Date | null = null;

  @Emit('selectFilter')
  selectFilter(): void {
    return;
  }

  @Emit('clearFilter')
  clearFilter(): void {
    return;
  }

  @Emit('submit')
  submit(): Date {
    if (!this.selectedDate) {
      return new Date();
    }
    return this.selectedDate;
  }
}
